import script from "./ZoomDiagnostic.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZoomDiagnostic.vue?vue&type=script&setup=true&lang=ts"

import "./ZoomDiagnostic.vue?vue&type=style&index=0&id=5ac5eeb7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac5eeb7"]])

export default __exports__